export default "__VITE_ASSET__CMJjPs2S__"